/* eslint-disable react/no-children-prop */
import React from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { FormattedMessage, useIntl } from 'react-intl';

const renderTime = ({ remainingTime }) => {
    const seconds = remainingTime % 60;
    return (
        <div className="timer">
            <div className="seconds">{seconds || '60'}</div>
            <div className="text">
                <FormattedMessage id="digital.barcode.seconds" />
            </div>
        </div>
    );
};

const Timer = (props) => {
    const { formatMessage } = useIntl();
    return (
        <div className="time-container">
            <div className="time-wrapper">
                <CountdownCircleTimer
                    ariaLabel={formatMessage({ id: 'countdown.timer' })}
                    children={renderTime}
                    colors={[
                        ['#52356E', 0.92],
                        ['#52356E', 0.92],
                        ['#ff0000', 0.08],
                    ]}
                    duration={120}
                    initialRemainingTime={60}
                    isPlaying
                    onComplete={props.handleClose}
                    size={135}
                    strokeWidth={5}
                    trailColor={['#d1d1d1']}
                />
            </div>
        </div>
    );
};

export default Timer;
